const getUTCDateRange = (start = new Date(), end = new Date()) => {
  const offset = new Date().getTimezoneOffset() * 1000

  return [new Date(start.getTime() + offset), new Date(end.getTime() + offset)]
}

export default getUTCDateRange
